import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isPlainObject from 'lodash/isPlainObject';
import negate from 'lodash/negate';
import lPick from 'lodash/pick';

export function isOdd(num) {
	return num % 2;
}

export function safeJsonParse(obj) {
  if (obj && typeof obj === 'string') {
    try {
      return JSON.parse(obj);
    } catch (e) {
      // Do nothing here
    }
  }
  return null;
}

export function isObject(val) {
  return val !== null && isPlainObject(val);
}

export function isNonArrayObject(val) {
  return isObject(val) && !Array.isArray(val);
}

export const isNotEmpty = negate(isEmpty);

export const isNotNil = negate(isNil);

export function isEmptyString(val) {
  if (typeof val !== 'string') return false;
  return !val.trim();
}

export function navigateOutApp(url = '') {
  return url && window.open(url, '_blank', 'noreferrer');
}

export function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function isNilOrEmptyIterables(val) {
  return (
    isNil(val) ||
    isEmptyString(val) ||
    (Array.isArray(val) && !val.length) ||
    (isNonArrayObject(val) && isEmpty(val))
  );
}

export function pick(obj, keys = [], regex) {
  const clonedObj = cloneDeep(obj);
  const regexMatchedKeys = regex ? Object.keys(clonedObj).filter(key => regex.test(key)) : [];
  const allKeys = [...new Set([...keys, ...regexMatchedKeys])];
  return lPick(clonedObj, allKeys);
}

export function toBoolean(val) {
  if (isNil(val)) return false;
  if (typeof val === 'boolean') return val; 
  if (typeof val === 'number') {
      if (isNaN(val) || val === Infinity || val === -Infinity) return false;
      return val !== 0;
  }
  if (typeof val === 'string') {
      return !['false', '0', 'null', 'undefined', '', 'NaN'].includes(val.trim().toLowerCase());
  }
  return Boolean(val);
}

export function deferToNextTick(callback) {
  setTimeout(callback, 0);
}
